import { apiGet, apiPost } from "./api";

function requirePositiveInteger(value, fieldName) {
  if (!Number.isInteger(value) || value <= 0) {
    throw new Error(`${fieldName} must be a positive integer.`);
  }

  return value;
}

function requireNonNegativeInteger(value, fieldName) {
  if (!Number.isInteger(value) || value < 0) {
    throw new Error(`${fieldName} must be a non-negative integer.`);
  }

  return value;
}

// GET CURRENT GAMEWEEK

export async function getCurrentGameweek(leagueId, options = {}) {
  const validLeagueId = requirePositiveInteger(leagueId, "League ID");
  return apiGet(`/Gameweeks/current?leagueId=${validLeagueId}`, options);
}

// GET FIXTURES

export async function getFixturesForGameweek(gameweekId, options = {}) {
  const validGameweekId = requirePositiveInteger(gameweekId, "Gameweek ID");
  return apiGet(`/Fixtures/gameweek/${validGameweekId}`, options);
}

// GET PREDICTIONS

export async function getPredictionsForGameweek(
  userId,
  leagueId,
  gameweekId,
  options = {}
) {
  const validUserId = requirePositiveInteger(userId, "User ID");
  const validLeagueId = requirePositiveInteger(leagueId, "League ID");
  const validGameweekId = requirePositiveInteger(gameweekId, "Gameweek ID");

  return apiGet(
    `/Predictions/user/${validUserId}/league/${validLeagueId}/gameweek/${validGameweekId}`,
    options
  );
}

// SAVE PREDICTION

function validatePredictionPayload(payload) {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
    throw new Error("Prediction payload is required.");
  }

  return {
    userId: requirePositiveInteger(payload.userId, "User ID"),
    leagueId: requirePositiveInteger(payload.leagueId, "League ID"),
    fixtureId: requirePositiveInteger(payload.fixtureId, "Fixture ID"),
    predictedHomeScore: requireNonNegativeInteger(
      payload.predictedHomeScore,
      "Home score"
    ),
    predictedAwayScore: requireNonNegativeInteger(
      payload.predictedAwayScore,
      "Away score"
    ),
  };
}

export async function savePrediction(payload, options = {}) {
  const validatedPayload = validatePredictionPayload(payload);
  return apiPost("/Predictions", validatedPayload, options);
}
